import React from 'react'
import { StyledIframe } from 'component-library/content/Iframe/Iframe.styled'
import { ThemeMargins } from 'component-library/__styling/settings/metrics'
import { useConsentGiven } from 'common/hooks/useConsentGiven'
import { ConsentLevel } from 'common/data/consent/consent.redux'

export interface Props {
    link: string
    height: number | string
    width?: number | string
    marginBottom?: keyof ThemeMargins
    innerRef?: ((element: HTMLIFrameElement) => void) | React.RefObject<HTMLIFrameElement> | null
    sandbox?: string
    frameBorder?: number
    consentRequiredLevel?: ConsentLevel
}

export const Iframe: React.FC<Props> = ({
    link,
    height,
    marginBottom,
    innerRef,
    sandbox,
    width,
    frameBorder,
    consentRequiredLevel = 1,
}) => {
    const consentGiven = useConsentGiven({
        consentRequiredLevel,
    })

    if (!consentGiven) {
        return null
    }

    return (
        <StyledIframe
            src={link}
            height={height}
            width={width}
            marginBottom={marginBottom}
            ref={innerRef}
            sandbox={sandbox}
            frameBorder={frameBorder}
        >
            Sorry, we can't show this content as your browser does not support iframes.
        </StyledIframe>
    )
}
